import React from 'react';
import { useDispatch } from 'react-redux';
import { SendFinalTest } from '../../../../store/finalTest/actions';
import { TFinalTest } from '../../../../store/finalTest/types';
import { TAnswerTest } from '../../../../store/interactive/types';
import { TRoom } from '../../../../store/sockets/types';
import { Button } from '../../../../test/components/ui';
import { Content } from './Content';

interface TestPassProps {
  test: TFinalTest;
  room: TRoom;
  error: string | null;
  handleSend: () => void;
}

export const TestPass: React.FC<TestPassProps> = React.memo(({ test, room, error, handleSend }) => {
  const [value, setValue] = React.useState<TAnswerTest[]>([] as TAnswerTest[]);
  const [currentQuestion, setCurrentQuestion] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);

  const dispatch = useDispatch();

  React.useEffect(() => {
    setValue([]);
    setCurrentQuestion(0);
  }, []);

  const changeValue = (answerId: number, questionId: number) => {
    const answer = { questionId: questionId, answerId: answerId };
    const answers = value.filter((item) => item.questionId !== questionId);
    setValue([...answers, answer]);
  };

  const sendValue = () => {
    setIsLoading(true);
    dispatch(
      SendFinalTest.request({
        data: {
          event_id: room.event_id,
          data: value,
        },
        callBack: () => {
          setIsLoading(false);
          handleSend();
        },
      })
    );
  };

  const answerHandler = () => {
    if (currentQuestion < test.questions.length - 1) {
      setCurrentQuestion((prevState) => prevState + 1);
    } else {
      sendValue();
    }
  };

  return (
    <div style={{ padding: '20px 50px' }}>
      <div style={{ width: '100%' }}>
        <Content type="pass" test={test} currentQuestion={currentQuestion} value={value} changeValue={changeValue} />
        <div style={{ textAlign: 'center' }}>
          {isLoading ? 'Почекайте ...' : <Button disabled={!value[currentQuestion]} onClick={answerHandler} title="Відповісти" />}
        </div>
      </div>
      {error && (
        <div style={{ color: 'red', textAlign: 'center' }}>
          <span>{error}</span>
        </div>
      )}
    </div>
  );
});
